import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/meh': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM328 176c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM336 320c13.2 0 24 10.8 24 24s-10.8 24-24 24h-176c-13.2 0-24-10.8-24-24s10.8-24 24-24h176z'
      }
    ]
  }
})
